var angular = require('angular');
var _module = angular.module('listreports.modals', []);


module.exports = _module;